/* ==========================================================================
   Luv Abominable: "Bom Blast" bomb game SMS pop-up (2026-10-23, Derrick)

   Flow:  trigger (delay / desktop exit intent) -> drag back from the bomb on the
          slingshot and let go (or tap Launch, tap the scene, press Space/Enter)
          -> the bomb flies into a stack of Bom boxes -> BOOM: explosion, pieces
          fly, screen shake -> the prize hang tag drops in. EVERY shot wins the
          same prize: a near miss is steered into the stack, a clear miss gets one
          more automatic try, and that second shot always lands. -> "Claim it" ->
          window.postscript.popups.open(popupId). Postscript owns the phone step,
          consent and the code. If its SDK is missing (blocked/failed), Claim is a
          real <a href> to the fallback link, so it still works.

   Lifecycle (once per visitor, cooldown after a dismiss, reopen tab, Postscript
   subscriber skip, scroll lock, the Postscript hold, the non-modal Claim bridge)
   is ported from Krazy Ambitions' slot machine (assets/kza-slot.js), which is
   verified live. Every tunable is a data-bbl-* attribute written by
   snippets/bom-blast.liquid from Theme settings > Bomb game pop-up. Nothing
   commercial lives here. No libraries: the game is one <canvas> with a small
   custom physics step.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-bom-blast]');
  if (!root || typeof root.showModal !== 'function') return;

  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function attr(n) { return (root.getAttribute('data-bbl-' + n) || '').trim(); }
  var cfg = {
    enabled:      attr('enabled') === 'true',
    popupId:      attr('popup-id'),
    fallbackUrl:  attr('fallback-url'),
    delay:        num(attr('delay'), 6),
    exitIntent:   attr('exit-intent') === 'true',
    cooldownDays: num(attr('cooldown-days'), 7),
    logo:         attr('logo'),
    force:        /[?&]bom_blast=1\b/.test(location.search)
  };
  // Auto-open only once it is switched on AND Claim has somewhere to go.
  var ready = cfg.enabled && !!(cfg.popupId || cfg.fallbackUrl);

  var KEY = 'bom_blast_v1';
  function readState() { try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } }
  function writeState(patch) {
    try { var s = readState(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function emit(action, extra) {
    var d = { action: action }; if (extra) for (var k in extra) d[k] = extra[k];
    try { document.dispatchEvent(new CustomEvent('bom:blast', { detail: d })); } catch (e) {}
  }

  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer  = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------------------------------------------------------- gating */

  function fromOurTexts() { return /utm_source=postscript/i.test(location.search); }
  function suppressedLocally() {
    if (cfg.force) return false;
    if (!ready || fromOurTexts()) return true;
    var s = readState();
    if (s.claimed) return true;
    if (s.dismissed && Date.now() - s.dismissed < cfg.cooldownDays * 864e5) return true;
    return false;
  }
  // getSubscriberId may be sync or a promise depending on the SDK build.
  function isSubscriber(cb) {
    var ps = window.postscript, r;
    if (!ps || typeof ps.getSubscriberId !== 'function') return cb(false);
    try { r = ps.getSubscriberId(); } catch (e) { return cb(false); }
    if (r && typeof r.then === 'function') {
      var done = false;
      r.then(function (id) { if (!done) { done = true; cb(!!id); } }, function () { if (!done) { done = true; cb(false); } });
      setTimeout(function () { if (!done) { done = true; cb(false); } }, 1500);
    } else cb(!!r);
  }
  /* --------------------------------------------------- Postscript hold (same rule as KZA: Postscript's screen must not show
     until the shopper taps Claim, "not before or during"). While the game is in play, Postscript's frame is kept invisible
     and click-through (html.bom-ps-hold, set in <head> by snippets/bom-blast-hold.liquid before Postscript loads) and its
     scroll lock is cancelled, even if its own trigger fires. Claim releases it. Only while not claimed. */
  var holding = document.documentElement.classList.contains('bom-ps-hold');
  function holdPostscript() { if (!holding) { holding = true; document.documentElement.classList.add('bom-ps-hold'); } }
  function releaseHold() { holding = false; document.documentElement.classList.remove('bom-ps-hold'); }

  // Never stack on the cart drawer or another dialog.
  function somethingElseOpen() {
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) if (open[i] !== root) return true;
    if (document.querySelector('.lv-cart-overlay.open')) return true;      // the theme's cart drawer (lv-cart-drawer)
    // Postscript's own pop-up, when it is actually visible (while we hold it, it is hidden and does not count)
    var ps = document.getElementById('ps__widget');
    if (ps && !holding) { var r = ps.getBoundingClientRect(); if (r.width > 200 && r.height > 200 && getComputedStyle(ps).visibility !== 'hidden') return true; }
    return false;
  }

  var shown = false, timer = null;
  // Exactly one open per page: the delay timer and desktop exit intent can both fire, and the subscriber check is async,
  // so the first trigger claims the slot before checking (KZA 2026-10-19: "it pops up once, and it instantly pops up again").
  function tryOpen() {
    if (shown) return;
    if (somethingElseOpen()) { timer = setTimeout(tryOpen, 4000); return; }
    shown = true; clearTimeout(timer); document.removeEventListener('mouseout', onExit);
    isSubscriber(function (sub) { if (sub && !cfg.force) return; open(); });
  }
  function onExit(e) {
    if (e.relatedTarget == null && e.clientY <= 0) {
      document.removeEventListener('mouseout', onExit);
      clearTimeout(timer); tryOpen();
    }
  }
  function arm() {
    // A preview link (?bom_blast=1) always starts from scratch, so the whole game can be reviewed again.
    if (cfg.force) { try { localStorage.removeItem(KEY); } catch (e) {} }
    var s = readState();
    if ((ready || cfg.force) && cfg.popupId && !s.claimed && !fromOurTexts()) holdPostscript();
    if (!cfg.force && s.claimed) return;
    if (tabWanted(s)) showTab(true);
    if (suppressedLocally()) return;
    setTimeout(warm, Math.max(0, cfg.delay - 3) * 1000);   // fetch the logo just before it can open
    if (cfg.delay >= 0) timer = setTimeout(tryOpen, (cfg.force ? Math.min(cfg.delay, 1) : cfg.delay) * 1000);
    if (cfg.exitIntent && finePointer) document.addEventListener('mouseout', onExit);
  }

  /* --------------------------------------------------------------- elements */

  var inner     = root.querySelector('[data-bbl-inner]');
  var stage     = root.querySelector('[data-bbl-stage]');
  var canvas    = root.querySelector('[data-bbl-canvas]');
  var launchBtn = root.querySelector('[data-bbl-launch]');
  var claimEl   = root.querySelector('[data-bbl-claim]');
  var live      = root.querySelector('[data-bbl-live]');
  var toastEl   = root.querySelector('[data-bbl-toast]');
  var boomEl    = root.querySelector('[data-bbl-boom]');
  var won = false, claimed = false;
  var game = 'ready';                      // ready | aiming | flying | boom | won (mirrored on data-bbl-state for the CSS)

  var keyboardUser = false;   // move focus to Claim only for keyboard users: no stray focus ring on touch
  root.addEventListener('keydown', function () { keyboardUser = true; }, true);
  root.addEventListener('pointerdown', function () { keyboardUser = false; }, true);

  function setState(s) { game = s; root.setAttribute('data-bbl-state', s); }

  /* ------------------------------------------------------- lazy art (once)
     The header logo and the Bom mark on the boxes both come from assets/bom-blast-logo.png (900 x 309, white wordmark,
     white swoosh, red B). The canvas cuts the swoosh + B out of it three ways: as is (for black boxes), all white (red
     boxes) and all red (white boxes and the bag). Drawing a CDN image only taints the canvas, which never reads pixels. */
  var warmed = false, logoImg = null, marks = null;
  var MARK_SRC = [70, 0, 606, 212];        // x, y, w, h of the swoosh + B inside the 900px-wide logo (the wordmark is below)
  function warm() {
    if (warmed) return; warmed = true;
    Array.prototype.forEach.call(root.querySelectorAll('img[data-src]'), function (img) {
      img.src = img.getAttribute('data-src'); img.removeAttribute('data-src');
    });
    if (cfg.logo && window.Image) {
      logoImg = new Image();
      logoImg.onload = function () { buildMarks(); draw(); };
      logoImg.src = cfg.logo;
    }
  }
  function buildMarks() {
    if (!logoImg || !logoImg.naturalWidth) return;
    var k = logoImg.naturalWidth / 900;    // still right if a resized logo is uploaded under the same name
    function cut(tint) {
      var c = document.createElement('canvas'); c.width = 240; c.height = 84;
      var x = c.getContext('2d');
      x.drawImage(logoImg, MARK_SRC[0] * k, MARK_SRC[1] * k, MARK_SRC[2] * k, MARK_SRC[3] * k, 0, 0, 240, 84);
      if (tint) { x.globalCompositeOperation = 'source-in'; x.fillStyle = tint; x.fillRect(0, 0, 240, 84); }
      return c;
    }
    try { marks = { full: cut(null), white: cut('#ffffff'), red: cut(RED) }; } catch (e) { marks = null; }
  }

  /* ------------------------------------------------------ scroll lock (html)
     showModal() traps focus but the page behind still scrolls on iOS; lock <html>
     (not <body>) and give the scrollbar's width back so nothing shifts. */
  var lockPad = '';
  function lockScroll() {
    var de = document.documentElement, sb = window.innerWidth - de.clientWidth;
    lockPad = de.style.paddingRight; de.classList.add('bom-blast-lock');
    if (sb > 0) de.style.paddingRight = sb + 'px';
  }
  function unlockScroll() { var de = document.documentElement; de.classList.remove('bom-blast-lock'); de.style.paddingRight = lockPad; }

  /* ------------------------------------------------------------ open/close */
  var opening = false;
  function artReady(cb) {
    var imgs = [root.querySelector('.bbl-logo')].filter(Boolean);
    var done = false, finish = function () { if (!done) { done = true; cb(); } };
    setTimeout(finish, 1200);
    Promise.all(imgs.map(function (i) {
      if (i.decode) return i.decode().catch(function () {});
      return new Promise(function (res) { if (i.complete) res(); else { i.onload = i.onerror = res; } });
    })).then(finish, finish);
  }
  function open() {
    if (root.open || opening) return;                              // never twice
    opening = true; shown = true; clearTimeout(timer);
    document.removeEventListener('mouseout', onExit);
    hideTab(); warm();
    artReady(function () { opening = false; if (!root.open) revealGame(); });
  }
  function revealGame() {
    var s = readState();
    if (s.won && !won) showWonInstant();
    // Reopened after a win on this page: show the finished result (a reopened dialog would otherwise replay its CSS animations).
    if (won) { root.classList.add('is-returning'); root.classList.remove('is-boom'); setState('won'); }
    else if (game === 'aiming') { drag = null; auto = null; kb = null; setState('ready'); }
    root.showModal(); lockScroll();
    root.focus({ preventScroll: true });
    writeState({ shown: Date.now() });
    requestAnimationFrame(function () { layout(); kick(); });
    emit('open', { won: won });
  }
  root.addEventListener('close', function () {
    unlockScroll();
    if (!root.open) stopLoop();
    if (!claimed) { writeState({ dismissed: Date.now() }); emit('dismiss', { won: won }); showTab(false); }
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-bbl-close]')) return root.close();
    // the backdrop: a click on the dialog element itself, outside its box (a drag released past the edge is not a dismiss)
    if (e.target === root && Date.now() - lastDragEnd > 400) {
      var r = root.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) root.close();
    }
  });
  function relayout() { if (root.open) { layout(); kick(); } }
  window.addEventListener('resize', relayout);
  if (window.ResizeObserver && stage) new ResizeObserver(relayout).observe(stage);

  /* ------------------------------------------------------------------ the game
     World units: x runs 0..340 across the scene, y runs UP from the ground line (y = 0). The canvas shows the world at
     one scale, s = min(width / 340, sky height / 270), anchored to the ground and centred, so the same scene fits a 360px
     phone and the desktop column. The ground band's height in px comes from CSS (--bbl-ground on the stage). Physics run in
     fixed 120 Hz steps (semi-implicit Euler) whatever the frame rate, and the aiming dots run the very same step, so
     they tell the truth. Everything is drawn in world units with y flipped (canvas y = -world y). */
  var ctx = canvas && canvas.getContext ? canvas.getContext('2d') : null;
  var RED = '#D61828', ASPHALT = '#1E1E1E';
  var WORLD_W = 340, MIN_SKY = 270, DT = 1 / 120;
  var G = 620, POWER = 7.2, MAX_PULL = 72, MIN_PULL = 14, BOMB_R = 13;
  var ANCHOR = { x: 63, y: 94 };                                   // the pouch at rest, between the prong tips
  var BASE = { x: 62, y: 0 }, FORK = { x: 62, y: 58 }, TIP_F = { x: 50, y: 99 }, TIP_B = { x: 76, y: 101 };
  var PALLET = { x0: 196, x1: 322, h: 10 };
  var STACK = { x0: 196, x1: 322, top: 140 };                      // the bomb's hit box: pallet, boxes and the bag's handles
  var TARGET = { x: 236, y: 62 };                                  // the default shot and the aim assist land here
  var WALL_L = 92;                                                 // boxes blown left bounce off here, right of the slingshot
  var Q = Math.PI / 2, TAU = Math.PI * 2;
  var view = { s: 1, ox: 0, gy: 0, cw: 0, ch: 0, dpr: 1, left: 0, right: WORLD_W, top: MIN_SKY };
  var bomb = null, pull = { x: 0, y: 0 }, pouch = { x: 0, y: 0, vx: 0, vy: 0 };
  var blocks = [], parts = [], scorch = null, ring = null, sky = null;
  var flash = 0, shake = 0, clock = 0, attempts = 0, boomT = 0;
  var drag = null, auto = null, kb = null, interacted = false, lastDragEnd = 0, toastT = 0;

  function easeOutCubic(p) { return 1 - Math.pow(1 - p, 3); }
  function easeOutBack(p) { var c = 1.7, c3 = c + 1; return 1 + c3 * Math.pow(p - 1, 3) + c * Math.pow(p - 1, 2); }
  function rng(seed) {                                             // tiny seeded random: the skyline is the same every time
    return function () { seed = (seed + 0x6D2B79F5) | 0; var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  }

  function layout() {
    if (!ctx) return;
    var r = canvas.getBoundingClientRect();
    if (r.width < 20 || r.height < 40) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1);           // 2x is crisp for flat shapes; 3x would add 2.25x the fill work
    var gp = parseFloat(getComputedStyle(stage).getPropertyValue('--bbl-ground')) || 16;
    canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr);
    view.dpr = dpr; view.cw = r.width; view.ch = r.height;
    view.gy = r.height - gp;
    view.s = Math.min(r.width / WORLD_W, view.gy / MIN_SKY);
    view.ox = (r.width / view.s - WORLD_W) / 2;
    view.left = -view.ox; view.right = WORLD_W + view.ox; view.top = view.gy / view.s;
    buildSky();
    draw();
  }
  function buildSky() {
    var R = rng(23), stars = [], towers = [], x = view.left - 8;
    for (var i = 0; i < 44; i++) stars.push({ x: view.left + R() * (view.right - view.left), y: 70 + R() * (view.top - 70), r: .6 + R() * .9, a: .12 + R() * .4 });
    while (x < view.right + 8) {                                    // a low skyline behind the scene
      var w = 15 + R() * 28, h = 24 + R() * 70, win = [];
      for (var wy = 10; wy < h - 6; wy += 9) for (var wx = 4; wx < w - 5; wx += 7) if (R() < .16) win.push(wx, wy);
      towers.push({ x: x, w: w, h: h, win: win }); x += w + R() * 2;
    }
    sky = { stars: stars, towers: towers };
  }

  /* the stack: a pallet (static), three boxes, two boxes, a shopping bag on top */
  function box(kind, x, y, w, h) { return { kind: kind, x: x, y: y, w: w, h: h, a: 0, vx: 0, vy: 0, va: 0, r: (w + h) / 4, live: false, sleep: true, still: 0 }; }
  function buildStack() {
    blocks = [
      box('white', 218, 29, 38, 38), box('black', 259, 29, 38, 38), box('red', 300, 29, 38, 38),
      box('red', 238.5, 67, 38, 38), box('white', 279.5, 67, 38, 38),
      box('bag', 259, 113, 34, 54)                                  // 54 tall: the handles are part of its box
    ];
  }
  // The aftermath without the physics (a returning winner, or reduced motion): knocked flat, one box tipped across two.
  var WRECK = [[170, 19, 0], [222, 29, 0], [301, 29, 0], [242, 69.1, .12], [262, 29, 0], [121, 18.6, -1.51]];
  function wreck() {
    if (!blocks.length) buildStack();
    blocks.forEach(function (b, i) { var w = WRECK[i]; b.x = w[0]; b.y = w[1]; b.a = w[2]; b.vx = b.vy = b.va = 0; b.live = true; b.sleep = true; });
  }
  function loadBomb() {
    bomb = { x: ANCHOR.x, y: ANCHOR.y, vx: 0, vy: 0, a: 0, va: 0, t: 0, state: 'loaded', drop: reduceMotion ? 1 : 0 };
    pull.x = pull.y = 0;
  }
  function groundAt(x) { return x > PALLET.x0 && x < PALLET.x1 ? PALLET.h : 0; }

  /* ---------------------------------------------------------------- physics */
  function stepBody(b, dt) { b.vy -= G * dt; b.x += b.vx * dt; b.y += b.vy * dt; }
  // 'hit' | 'miss' | null for a bomb centred at x, y. Generous on purpose: the stack's whole box counts (even its empty
  // top corners) and so does the ground right beside it, because a bomb does not need a direct hit.
  function hitTest(x, y) {
    if (x + BOMB_R > STACK.x0 && x - BOMB_R < STACK.x1 && y - BOMB_R < STACK.top) return 'hit';
    if (y - BOMB_R <= 0) return x > STACK.x0 - 34 && x < STACK.x1 + 34 ? 'hit' : 'miss';
    if (x > view.right + 40 || x < view.left - 40) return 'miss';
    return null;
  }
  // Runs a launch forward with the live step. Fills `dots` (x, y pairs every 4 steps) for the aiming preview.
  function predict(x, y, vx, vy, dots) {
    var b = { x: x, y: y, vx: vx, vy: vy }, minD = 1e9, res = null;
    for (var i = 1; i <= 720 && !res; i++) {
      stepBody(b, DT);
      var dx = Math.max(STACK.x0 - b.x, 0, b.x - STACK.x1), dy = Math.max(b.y - STACK.top, 0);
      minD = Math.min(minD, Math.sqrt(dx * dx + dy * dy) - BOMB_R);
      res = hitTest(b.x, b.y);
      if (dots) { if (i % 4 === 0) dots.push(b.x, b.y); if (dots.length >= 52) break; }
    }
    return { hit: res === 'hit', minD: minD };
  }
  // The launch velocity that lands on TARGET from (x0, y0): at the shopper's own angle when it is a sane one,
  // otherwise at the nearest lob that works. Checked with predict(), so it agrees with the live step.
  function solve(x0, y0, th) {
    var dx = TARGET.x - x0, dy = TARGET.y - y0, tries = [th, .87, .75, 1, .62, 1.12];
    for (var i = 0; i < tries.length; i++) {
      var t = tries[i]; if (!(t > .35 && t < 1.25)) continue;
      var c = Math.cos(t), den = 2 * c * c * (dx * Math.tan(t) - dy);
      if (den <= 0) continue;
      var v = Math.sqrt(G * dx * dx / den);
      if (v > 700) continue;
      if (predict(x0, y0, v * c, v * Math.sin(t)).hit) return { vx: v * c, vy: v * Math.sin(t) };
    }
    return null;
  }
  // The default shot (Launch, a tap, Space/Enter): a 50 degree lob into the stack. The pull moves the launch point,
  // so solve from where the bomb will actually be, a few times over (it settles at once).
  var DEF = null;
  function defaultPull() {
    if (DEF) return DEF;
    var p = { x: -30, y: -30 };
    for (var i = 0; i < 4; i++) {
      var v = solve(ANCHOR.x + p.x, ANCHOR.y + p.y, .87) || { vx: 205, vy: 245 };
      p = { x: -v.vx / POWER, y: -v.vy / POWER };
    }
    return (DEF = p);
  }

  function step(dt) {
    clock += dt;
    if (bomb && bomb.state === 'loaded') {
      if (bomb.drop < 1) bomb.drop = Math.min(1, bomb.drop + dt / .38);
      if (auto) {                                                  // Launch/tap: the bomb pulls itself back, then lets go
        auto.t += dt;
        var d = defaultPull(), e = easeOutCubic(Math.min(1, auto.t / auto.dur));
        pull.x = d.x * e; pull.y = d.y * e;
        if (auto.t >= auto.dur + .1) { var via = auto.via; auto = null; fire({ x: d.x, y: d.y }, via); }
      } else if (!drag && !kb) {                                   // a short pull that was let go eases home
        pull.x -= pull.x * 16 * dt; pull.y -= pull.y * 16 * dt;
      }
    }
    if (bomb && bomb.state === 'loaded') { pouch.x = pull.x; pouch.y = pull.y; pouch.vx = pouch.vy = 0; }
    else {                                                         // after a shot the band snaps back and wobbles
      pouch.vx += (-pouch.x * 900 - pouch.vx * 22) * dt; pouch.vy += (-pouch.y * 900 - pouch.vy * 22) * dt;
      pouch.x += pouch.vx * dt; pouch.y += pouch.vy * dt;
    }
    if (bomb && bomb.state === 'flying') {
      stepBody(bomb, dt); bomb.a += bomb.va * dt; bomb.t += dt;
      var hit = hitTest(bomb.x, bomb.y);
      if (hit === 'hit') detonate(bomb.x, bomb.y);
      else if (hit === 'miss') missed();
      else if (bomb.t > 3.5) detonate(TARGET.x, TARGET.y);         // nobody is ever stranded: the fuse runs out at the stack
    }
    if (blocks.length) stepBlocks(dt);
    if (parts.length) stepParts(dt);
    if (ring && (ring.t += dt) > .5) ring = null;
    if (flash > 0) flash = Math.max(0, flash - dt * 5);
    if (shake > 0) shake = Math.max(0, shake - dt * 2.2);
    if ((game === 'boom' || game === 'won') && clock - boomT > 6) blocks.forEach(function (b) { b.sleep = true; });   // hard stop
  }

  // Boxes after the blast: rigid-ish rectangles that tumble, bounce off the ground and the scene's edges, tip onto
  // their nearest face and go to sleep once still. They knock into each other as circles (cheap, reads as solid).
  function stepBlocks(dt) {
    var i, j, b;
    for (i = 0; i < blocks.length; i++) {
      b = blocks[i];
      if (!b.live || b.sleep) continue;
      b.vy -= G * dt; b.vx -= b.vx * .15 * dt;
      b.x += b.vx * dt; b.y += b.vy * dt; b.a += b.va * dt;
      var c = Math.abs(Math.cos(b.a)), s = Math.abs(Math.sin(b.a));
      var ex = b.w / 2 * c + b.h / 2 * s, ey = b.w / 2 * s + b.h / 2 * c, gh = groundAt(b.x);
      var onGround = b.y - ey <= gh + .5;
      if (b.y - ey < gh) {
        b.y = gh + ey;
        if (b.vy < 0) b.vy = b.vy < -60 ? -b.vy * .28 : 0;
        b.vx -= b.vx * 6 * dt;
      }
      if (onGround) { var tgt = Math.round(b.a / Q) * Q; b.va += ((tgt - b.a) * 70 - b.va * 9) * dt; }
      if (b.x - ex < WALL_L) { b.x = WALL_L + ex; b.vx = Math.abs(b.vx) * .45; }   // debris stays clear of the slingshot
      if (b.x + ex > view.right) { b.x = view.right - ex; b.vx = -Math.abs(b.vx) * .45; }
      var slow = Math.abs(b.vx) < 8 && Math.abs(b.vy) < 8 && Math.abs(b.va) < .35;
      b.still = slow ? b.still + dt : 0;
      if (b.still > .35) {
        if (onGround) b.a = Math.round(b.a / Q) * Q;
        b.vx = b.vy = b.va = 0; b.sleep = true;
      }
    }
    for (i = 0; i < blocks.length; i++) for (j = i + 1; j < blocks.length; j++) collideBlocks(blocks[i], blocks[j]);
  }
  function collideBlocks(a, b) {
    if (!a.live || !b.live || (a.sleep && b.sleep)) return;
    var dx = b.x - a.x, dy = b.y - a.y, d2 = dx * dx + dy * dy, min = a.r + b.r;
    if (d2 >= min * min || d2 < 1e-4) return;
    var d = Math.sqrt(d2), nx = dx / d, ny = dy / d, over = min - d;
    var rv = (b.vx - a.vx) * nx + (b.vy - a.vy) * ny;
    if (rv < -150) { a.sleep = false; b.sleep = false; a.still = b.still = 0; }   // a hard knock wakes a resting box
    var ma = a.sleep ? 0 : 1, mb = b.sleep ? 0 : 1, tot = ma + mb;               // inverse masses: a sleeping box is a wall
    a.x -= nx * over * ma / tot; a.y -= ny * over * ma / tot;
    b.x += nx * over * mb / tot; b.y += ny * over * mb / tot;
    if (rv < 0) {
      var jn = -1.25 * rv / tot;                                    // restitution .25
      a.vx -= jn * nx * ma; a.vy -= jn * ny * ma; b.vx += jn * nx * mb; b.vy += jn * ny * mb;
    }
  }
  function stepParts(dt) {
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i]; p.t += dt;
      if (p.t >= p.life) { parts[i] = parts[parts.length - 1]; parts.pop(); continue; }
      if (p.k === 'spark') p.vy -= G * .5 * dt;
      else if (p.k === 'shard') {
        p.vy -= G * dt; p.rot += p.vr * dt;
        var gh = groundAt(p.x) + 1;
        if (p.y < gh && p.vy < 0) { p.y = gh; p.vy *= -.32; p.vx *= .55; p.vr *= .5; }
      } else {                                                     // fire and smoke billow out, slow down and rise
        var k = p.k === 'fire' ? 3.2 : 1.4;
        p.vx -= p.vx * k * dt; p.vy -= p.vy * k * dt; p.vy += (p.k === 'fire' ? 60 : 26) * dt;
      }
      p.x += p.vx * dt; p.y += p.vy * dt;
    }
  }

  /* ------------------------------------------------------------ launch, miss, BOOM */
  function fire(p, via) {
    if (!bomb || bomb.state !== 'loaded' || (game !== 'ready' && game !== 'aiming')) return;
    attempts++;
    var x0 = ANCHOR.x + p.x, y0 = ANCHOR.y + p.y, vx = -p.x * POWER, vy = -p.y * POWER;
    var pr = predict(x0, y0, vx, vy);
    // Nobody loses: a near miss (within about three bomb widths) is steered into the stack, and the second shot always lands.
    if (!pr.hit && (attempts > 1 || pr.minD < 40)) {
      var v = solve(x0, y0, Math.atan2(vy, vx));
      if (v) { vx = v.vx; vy = v.vy; }
    }
    bomb.x = x0; bomb.y = y0; bomb.vx = vx; bomb.vy = vy; bomb.va = 5 + Math.random() * 3; bomb.t = 0;
    bomb.state = 'flying'; bomb.drop = 1;
    pouch.x = p.x; pouch.y = p.y; pouch.vx = pouch.vy = 0;
    pull.x = pull.y = 0; kb = null; auto = null;
    setState('flying');
    emit('launch', { via: via, attempt: attempts });
    kick();
  }
  function missed() {
    var b = bomb; b.state = 'gone';
    if (b.y < view.top && b.x > view.left && b.x < view.right) puff(b.x, Math.max(b.y, BOMB_R));   // a dud fizzles where it lands
    emit('miss', { attempt: attempts });
    setTimeout(function () { showToast(); loadBomb(); setState('ready'); kick(); }, 650);
  }
  function showToast() {
    if (!toastEl) return;
    toastEl.classList.add('is-on');
    if (live) live.textContent = toastEl.textContent.trim();
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
  }
  function detonate(x, y) {
    if (game === 'boom' || game === 'won') return;
    if (bomb) bomb.state = 'gone';
    setState('boom'); boomT = clock;
    scorch = { x: Math.max(STACK.x0 - 10, Math.min(STACK.x1 + 10, x)) };
    placeBoom(x, y);
    root.classList.add('is-boom');
    if (toastEl) toastEl.classList.remove('is-on');
    if (reduceMotion) wreck();                                     // reduced motion: the stack is simply knocked down, no shake or particles
    else {
      blast(x, y); explode(x, y);
      flash = 1; shake = 1;
      if (inner) { inner.classList.remove('is-shaking'); void inner.offsetWidth; inner.classList.add('is-shaking'); }
      if (navigator.vibrate) { try { navigator.vibrate([40, 30, 140]); } catch (e) {} }   // Android; iOS ignores it
    }
    emit('boom');
    setTimeout(win, reduceMotion ? 350 : 1050);                    // the tag drops in as the BOOM lettering clears
    kick();
  }
  // The BOOM lettering (HTML, crisp at any size) sits just above the hit, so the fireball shows beneath it, clear of the edges.
  function placeBoom(x, y) {
    if (!boomEl || !view.cw) return;
    var px = (x + view.ox) * view.s, py = view.gy - (y + 70) * view.s;
    px = Math.max(view.cw * .32, Math.min(view.cw * .68, px)); py = Math.max(view.ch * .3, Math.min(view.ch * .72, py));
    boomEl.style.setProperty('--bx', px.toFixed(1) + 'px'); boomEl.style.setProperty('--by', py.toFixed(1) + 'px');
  }
  function blast(x, y) {
    blocks.forEach(function (b) {
      var dx = b.x - x, dy = b.y - y, d = Math.sqrt(dx * dx + dy * dy) || 1, k = 680 / (1 + d / 65);
      b.live = true; b.sleep = false; b.still = 0;
      b.vx += dx / d * k + (Math.random() - .5) * 80;
      b.vy += dy / d * k * .8 + 200 + Math.random() * 110;         // everything is thrown up hard: it reads as a blast
      b.va += (Math.random() - .5) * 10 + (dx >= 0 ? 4 : -4);
      for (var i = 0; i < 5; i++) shard(b);
    });
  }
  var SHARD = { white: '#F2F2F2', red: RED, black: '#4a4a4a', bag: '#F2F2F2' };
  function shard(b) {
    var a = Math.random() * TAU, v = 140 + Math.random() * 300;
    parts.push({ k: 'shard', x: b.x + (Math.random() - .5) * b.w * .6, y: b.y + (Math.random() - .5) * b.h * .6,
                 vx: Math.cos(a) * v, vy: Math.abs(Math.sin(a)) * v + 80, w: 3 + Math.random() * 5, h: 2 + Math.random() * 3,
                 rot: Math.random() * 6, vr: (Math.random() - .5) * 20, c: SHARD[b.kind], t: 0, life: 2.4 + Math.random() * .8 });
  }
  function explode(x, y) {
    var i, a, v;
    ring = { x: x, y: y, t: 0 };
    for (i = 0; i < 16; i++) { a = Math.random() * TAU; v = 20 + Math.random() * 60;
      parts.push({ k: 'smoke', x: x + Math.cos(a) * 10, y: y + Math.sin(a) * 10, vx: Math.cos(a) * v, vy: Math.sin(a) * v * .6 + 30, r: 14 + Math.random() * 12, t: 0, life: 1.6 + Math.random() * 1.1 }); }
    for (i = 0; i < 26; i++) { a = Math.random() * TAU; v = 50 + Math.random() * 190;
      parts.push({ k: 'fire', x: x + Math.cos(a) * 6, y: y + Math.sin(a) * 6, vx: Math.cos(a) * v, vy: Math.sin(a) * v + 40, r: 9 + Math.random() * 14, t: 0, life: .4 + Math.random() * .5 }); }
    for (i = 0; i < 34; i++) { a = Math.random() * TAU; v = 260 + Math.random() * 320;
      parts.push({ k: 'spark', x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v + 80, t: 0, life: .35 + Math.random() * .45 }); }
  }
  function puff(x, y) {
    if (reduceMotion) return;
    for (var i = 0; i < 7; i++) { var a = Math.random() * TAU, v = 10 + Math.random() * 30;
      parts.push({ k: 'smoke', x: x, y: y, vx: Math.cos(a) * v, vy: Math.abs(Math.sin(a)) * v + 10, r: 5 + Math.random() * 5, t: 0, life: .8 + Math.random() * .5 }); }
  }
  function win() {
    if (won) return;
    won = true;
    root.classList.remove('is-returning');
    setState('won');
    writeState({ won: Date.now() });
    if (live) live.textContent = live.getAttribute('data-bbl-live-won') || '';
    emit('win');
    // The Launch button just disappeared, so focus would fall to <body>: keep it in the dialog.
    if (root.open) { if (keyboardUser && claimEl) claimEl.focus(); else root.focus({ preventScroll: true }); }
  }
  // A returning winner (reopened from the tab, or another page): the aftermath and the prize at once, no replay.
  function showWonInstant() {
    won = true;
    root.classList.add('is-returning');
    wreck(); bomb = null; scorch = { x: TARGET.x };
  }

  /* ----------------------------------------------------------------- input
     Drag anywhere on the scene: the bomb follows the finger's movement (not its position, so a thumb that lands
     beside the bomb still works), up to MAX_PULL. A tap without a drag launches the default shot, like Launch.
     Keyboard: Space/Enter launches the default shot; the arrow keys aim first (left/right = higher/flatter,
     up/down = more/less power) and then Space/Enter (or Launch) lets that aim fly. */
  function setPull(x, y) {
    x = Math.min(x, 6);                                            // pulled back, not pushed forward
    var L = Math.sqrt(x * x + y * y); if (L > MAX_PULL) { x *= MAX_PULL / L; y *= MAX_PULL / L; }
    y = Math.max(y, BOMB_R + 2 - ANCHOR.y);                         // never through the ground
    x = Math.max(x, view.left + BOMB_R + 3 - ANCHOR.x);             // never off the scene's left edge
    pull.x = x; pull.y = y;
  }
  function canAim() { return bomb && bomb.state === 'loaded' && (game === 'ready' || game === 'aiming') && !auto; }
  function defaultShot(via) {
    if (!canAim() || drag) return;
    if (kb) return fire({ x: pull.x, y: pull.y }, via);            // a keyboard aim is set: launch it as aimed
    interacted = true; bomb.drop = 1; setState('aiming');
    auto = { t: 0, dur: reduceMotion ? .08 : .4, via: via };
    kick();
  }
  if (canvas) {
    canvas.addEventListener('pointerdown', function (e) {
      if (!canAim() || game !== 'ready' || e.button > 0) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, moved: false };
      try { canvas.setPointerCapture(e.pointerId); } catch (x) {}
      interacted = true; kb = null; bomb.drop = 1; setState('aiming'); kick();
      e.preventDefault();
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (Math.abs(dx) + Math.abs(dy) > 6) drag.moved = true;
      setPull(dx / view.s, -dy / view.s);
    });
    var release = function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag; drag = null; lastDragEnd = Date.now();
      setState('ready');
      if (e.type === 'pointercancel') return;
      if (!d.moved) { pull.x = pull.y = 0; return defaultShot('tap'); }
      if (Math.sqrt(pull.x * pull.x + pull.y * pull.y) < MIN_PULL) return;   // too short: it eases back home
      fire({ x: pull.x, y: pull.y }, 'drag');
    };
    canvas.addEventListener('pointerup', release);
    canvas.addEventListener('pointercancel', release);
  }
  launchBtn && launchBtn.addEventListener('click', function () { defaultShot('button'); });
  root.addEventListener('keydown', function (e) {
    if ((e.target !== root && e.target !== canvas) || !canAim() || drag) return;
    var k = e.key;
    if (k === 'Enter' || k === ' ' || k === 'Spacebar') { e.preventDefault(); defaultShot('key'); return; }
    var da = k === 'ArrowLeft' ? 1 : k === 'ArrowRight' ? -1 : 0, dp = k === 'ArrowUp' ? 1 : k === 'ArrowDown' ? -1 : 0;
    if (!da && !dp) return;
    e.preventDefault();
    if (!kb) { var d = defaultPull(); kb = { ang: Math.atan2(-d.y, -d.x), len: Math.sqrt(d.x * d.x + d.y * d.y) }; }
    kb.ang = Math.max(.2, Math.min(1.4, kb.ang + da * .05));
    kb.len = Math.max(MIN_PULL, Math.min(MAX_PULL, kb.len + dp * 2.5));
    pull.x = -Math.cos(kb.ang) * kb.len; pull.y = -Math.sin(kb.ang) * kb.len;
    interacted = true; bomb.drop = 1; setState('aiming'); kick();
  });

  /* ------------------------------------------------------------------ loop
     Runs only while something moves (and while a loaded bomb's fuse flickers); stops when the dialog closes. */
  var raf = 0, running = false, last = 0, acc = 0;
  function busy() {
    if (!root.open) return false;
    if (game === 'aiming' || game === 'flying' || game === 'boom' || auto || drag) return true;
    if (parts.length || ring || flash > 0 || shake > 0) return true;
    if (Math.abs(pouch.x) + Math.abs(pouch.y) + Math.abs(pouch.vx) + Math.abs(pouch.vy) > .05) return true;
    for (var i = 0; i < blocks.length; i++) if (blocks[i].live && !blocks[i].sleep) return true;
    return !!(bomb && bomb.state === 'loaded' && (!reduceMotion || bomb.drop < 1));
  }
  function kick() { if (running || !ctx || !root.open) return; running = true; last = performance.now(); acc = 0; raf = requestAnimationFrame(frame); }
  function stopLoop() { running = false; cancelAnimationFrame(raf); }
  function frame(now) {
    if (!running) return;
    acc += Math.min(.05, Math.max(0, (now - last) / 1000)); last = now;
    while (acc >= DT) { step(DT); acc -= DT; }
    draw();
    if (busy()) raf = requestAnimationFrame(frame); else running = false;
  }

  /* ------------------------------------------------------------------ drawing */
  function circle(x, y, r) { ctx.beginPath(); ctx.arc(x, -y, r, 0, TAU); ctx.fill(); }
  function seg(a, bx, by, w, c) { ctx.strokeStyle = c; ctx.lineWidth = w; ctx.beginPath(); ctx.moveTo(a.x, -a.y); ctx.lineTo(bx, -by); ctx.stroke(); }

  function draw() {
    if (!ctx || !view.cw) return;
    var d = view.dpr, s = view.s, sx = 0, sy = 0;
    if (shake > 0) { var m = shake * shake * 7; sx = (Math.random() - .5) * 2 * m; sy = (Math.random() - .5) * 2 * m; }
    ctx.setTransform(d, 0, 0, d, 0, 0);
    ctx.fillStyle = '#000'; ctx.fillRect(0, 0, view.cw, view.ch);
    ctx.setTransform(d * s, 0, 0, d * s, d * (view.ox * s + sx), d * (view.gy + sy));
    ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    drawSky(); drawGround(); drawPallet();
    for (var i = 0; i < blocks.length; i++) drawBox(blocks[i]);
    drawSling();
    drawParts();
    if (ring) {
      var q = ring.t / .5;
      ctx.strokeStyle = 'rgba(255,255,255,' + (.85 * (1 - q)).toFixed(3) + ')'; ctx.lineWidth = 4 * (1 - q) + .5;
      ctx.beginPath(); ctx.arc(ring.x, -ring.y, 12 + q * 150, 0, TAU); ctx.stroke();
    }
    if (flash > 0) {
      ctx.setTransform(d, 0, 0, d, 0, 0);
      ctx.fillStyle = 'rgba(255,255,255,' + (flash * .8).toFixed(3) + ')'; ctx.fillRect(0, 0, view.cw, view.ch);
    }
  }
  function drawSky() {
    var w = view.right - view.left + 40, g = ctx.createRadialGradient(262, -70, 10, 262, -70, 250);
    g.addColorStop(0, 'rgba(214,24,40,.28)'); g.addColorStop(1, 'rgba(214,24,40,0)');   // a red glow behind the stack
    ctx.fillStyle = g; ctx.fillRect(view.left - 20, -view.top - 20, w, view.top + 20);
    if (!sky) return;
    ctx.fillStyle = '#fff';
    sky.stars.forEach(function (st) { ctx.globalAlpha = st.a; ctx.fillRect(st.x, -st.y, st.r, st.r); });
    ctx.globalAlpha = 1;
    sky.towers.forEach(function (t) {
      ctx.fillStyle = '#121212'; ctx.fillRect(t.x, -t.h, t.w, t.h);
      ctx.fillStyle = 'rgba(255,255,255,.07)';
      for (var i = 0; i < t.win.length; i += 2) ctx.fillRect(t.x + t.win[i], -t.win[i + 1], 2.4, 3.2);
    });
  }
  function drawGround() {
    var x = view.left - 30, w = view.right - view.left + 60;
    ctx.fillStyle = ASPHALT; ctx.fillRect(x, 0, w, view.ch / view.s + 40);
    ctx.fillStyle = '#3a3a3a'; ctx.fillRect(x, 0, w, 1.4);          // the curb's lit edge
    ctx.fillStyle = 'rgba(0,0,0,.55)';                               // the slingshot's shadow
    ctx.beginPath(); ctx.ellipse(BASE.x, 1, 16, 2.6, 0, 0, TAU); ctx.fill();
    if (scorch) { ctx.fillStyle = 'rgba(0,0,0,.8)'; ctx.beginPath(); ctx.ellipse(scorch.x, 1, 62, 5, 0, 0, TAU); ctx.fill(); }
  }
  function drawPallet() {
    ctx.fillStyle = '#3c3c3c';
    [PALLET.x0 + 4, (PALLET.x0 + PALLET.x1) / 2 - 7, PALLET.x1 - 18].forEach(function (x) { ctx.fillRect(x, -6.5, 14, 6.5); });
    ctx.fillStyle = '#5a5a5a'; ctx.fillRect(PALLET.x0, -PALLET.h, PALLET.x1 - PALLET.x0, 4);
  }

  // Bom boxes: white with a red mark, red with a white mark, black (white keyline) with the full-colour mark; the bag on top.
  var KIND = {
    white: { body: '#F2F2F2', edge: '#000', shade: 'rgba(0,0,0,.13)', lid: 'rgba(0,0,0,.18)', mark: 'red' },
    red:   { body: RED, edge: '#000', shade: 'rgba(0,0,0,.22)', lid: 'rgba(0,0,0,.24)', mark: 'white' },
    black: { body: '#000', edge: '#fff', shade: 'rgba(255,255,255,.07)', lid: 'rgba(255,255,255,.26)', mark: 'full' },
    bag:   { body: '#F2F2F2', edge: '#000', shade: 'rgba(0,0,0,.12)', mark: 'red' }
  };
  function drawMark(which, cx, cy, mw) {
    var mh = mw * 84 / 240;
    if (marks) { ctx.drawImage(marks[which], cx - mw / 2, cy - mh / 2, mw, mh); return; }
    ctx.fillStyle = which === 'white' ? '#fff' : RED;              // the logo has not loaded (yet): a plain B
    ctx.font = (mw * .6).toFixed(1) + 'px Anton, Impact, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText('B', cx, cy + mw * .04);
  }
  function drawBox(b) {
    var k = KIND[b.kind], w = b.w, h = b.h;
    ctx.save(); ctx.translate(b.x, -b.y); ctx.rotate(b.a);
    if (b.kind === 'bag') {
      var t = -h / 2 + 12;                                          // the body's top; the handles fill the 12 above it
      ctx.strokeStyle = RED; ctx.lineWidth = 2.2;                  // rope handles
      ctx.beginPath(); ctx.moveTo(-w * .24, t + 1); ctx.bezierCurveTo(-w * .24, t - 15, w * .24, t - 15, w * .24, t + 1); ctx.stroke();
      ctx.fillStyle = k.body; ctx.beginPath();
      ctx.moveTo(-w / 2 + 2, t); ctx.lineTo(w / 2 - 2, t); ctx.lineTo(w / 2, h / 2); ctx.lineTo(-w / 2, h / 2); ctx.closePath(); ctx.fill();
      ctx.lineWidth = 1.6; ctx.strokeStyle = k.edge; ctx.stroke();
      ctx.fillStyle = 'rgba(0,0,0,.12)'; ctx.fillRect(-w / 2 + 2.5, t + .8, w - 5, 4);   // the folded top
      ctx.fillStyle = k.shade; ctx.fillRect(-w / 2 + 1, h / 2 - h * .12, w - 2, h * .12 - .8);
      drawMark('red', 0, 10, w * .78);
    } else {
      ctx.fillStyle = k.body; ctx.fillRect(-w / 2, -h / 2, w, h);
      ctx.fillStyle = k.shade; ctx.fillRect(-w / 2, h / 2 - h * .16, w, h * .16);   // shadowed base
      ctx.fillStyle = k.lid; ctx.fillRect(-w / 2, -h / 2 + h * .21, w, 1.2);          // lid seam
      drawMark(k.mark, 0, h * .07, w * .76);
      ctx.lineWidth = 1.6; ctx.strokeStyle = k.edge; ctx.strokeRect(-w / 2 + .8, -h / 2 + .8, w - 1.6, h - 1.6);
    }
    ctx.restore();
  }

  // The slingshot, back to front: back prong, back band, pouch, bomb, front band, front prong. While the bomb is
  // loaded and nobody has touched it, it gives a small tug every few seconds, so the scene shows it can be pulled.
  function idleTug() {
    if (game !== 'ready' || interacted || reduceMotion || !bomb || bomb.state !== 'loaded' || bomb.drop < 1) return 0;
    var ph = clock % 3.6; return ph > 2.4 && ph < 3.2 ? Math.sin((ph - 2.4) / .8 * Math.PI) : 0;
  }
  function drawSling() {
    var loaded = bomb && bomb.state === 'loaded', px = ANCHOR.x + pouch.x, py = ANCHOR.y + pouch.y, bx = 0, by = 0;
    if (loaded) {
      var dp = defaultPull(), dl = Math.sqrt(dp.x * dp.x + dp.y * dp.y), tug = idleTug() * 12;
      var ox = pull.x + dp.x / dl * tug, oy = pull.y + dp.y / dl * tug, ol = Math.sqrt(ox * ox + oy * oy);
      bx = ANCHOR.x + ox; by = ANCHOR.y + oy + (1 - easeOutBack(bomb.drop)) * 80;   // a new bomb drops into the pouch
      px = ANCHOR.x + ox; py = ANCHOR.y + oy;
      if (ol > 1) { px += ox / ol * BOMB_R * .8; py += oy / ol * BOMB_R * .8; } else px -= BOMB_R * .8;
    }
    seg(FORK, TIP_B.x, TIP_B.y, 7, '#BDBDBD');
    seg(TIP_B, px, py, 3.2, '#A3121F');
    ctx.fillStyle = '#2a2a2a'; circle(px, py, 3.6);
    if (loaded) drawBomb(bx, by, 0);
    seg(TIP_F, px, py, 3.8, RED);
    seg(BASE, FORK.x, FORK.y, 9, '#E4E4E4');
    seg(FORK, TIP_F.x, TIP_F.y, 7, '#E4E4E4');
    if (bomb && bomb.state === 'flying') drawBomb(bomb.x, bomb.y, bomb.a);
    if (game === 'aiming' && (drag || kb || auto)) drawDots();
  }
  function drawBomb(x, y, a) {
    var r = BOMB_R;
    ctx.save(); ctx.translate(x, -y); ctx.rotate(a);
    ctx.strokeStyle = '#E9D7B0'; ctx.lineWidth = 2.2;               // the fuse, curling up out of the collar
    ctx.beginPath(); ctx.moveTo(r * .62, -r * .62); ctx.quadraticCurveTo(r * 1.45, -r * 1.25, r * 1.05, -r * 1.9); ctx.stroke();
    ctx.save(); ctx.translate(r * .68, -r * .68); ctx.rotate(Math.PI / 4);
    ctx.fillStyle = '#333'; ctx.fillRect(-4.6, -3.4, 9.2, 6.2);
    ctx.strokeStyle = '#fff'; ctx.lineWidth = 1.3; ctx.strokeRect(-4.6, -3.4, 9.2, 6.2);
    ctx.restore();
    ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(0, 0, r + 1.7, 0, TAU); ctx.fill();   // a white sticker keyline
    var g = ctx.createRadialGradient(-r * .4, -r * .45, 1, 0, 0, r);
    g.addColorStop(0, '#5a5a5a'); g.addColorStop(.45, '#161616'); g.addColorStop(1, '#000');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, r, 0, TAU); ctx.fill();
    ctx.fillStyle = 'rgba(255,255,255,.8)'; ctx.beginPath(); ctx.ellipse(-r * .4, -r * .42, r * .3, r * .17, -.7, 0, TAU); ctx.fill();
    spark(r * 1.05, -r * 1.9);
    ctx.restore();
  }
  function spark(x, y) {                                           // canvas coordinates, inside the bomb's transform
    var g = ctx.createRadialGradient(x, y, 0, x, y, 9);
    g.addColorStop(0, 'rgba(255,201,60,.75)'); g.addColorStop(1, 'rgba(255,120,30,0)');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, 9, 0, TAU); ctx.fill();
    ctx.strokeStyle = '#FFC93C'; ctx.lineWidth = 1.3; ctx.beginPath();
    for (var i = 0; i < 8; i++) {
      var a = i / 8 * TAU + clock * 3, L = 3.5 + (reduceMotion ? 1.5 : Math.random() * 4);
      ctx.moveTo(x + Math.cos(a) * 1.5, y + Math.sin(a) * 1.5); ctx.lineTo(x + Math.cos(a) * L, y + Math.sin(a) * L);
    }
    ctx.stroke();
    ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(x, y, 1.7, 0, TAU); ctx.fill();
  }
  function drawDots() {
    if (Math.sqrt(pull.x * pull.x + pull.y * pull.y) < MIN_PULL * .6) return;
    var dots = [];
    predict(ANCHOR.x + pull.x, ANCHOR.y + pull.y, -pull.x * POWER, -pull.y * POWER, dots);
    ctx.fillStyle = '#fff';
    for (var i = 0, n = dots.length / 2; i < n; i++) {
      ctx.globalAlpha = .9 - i / n * .65;
      circle(dots[2 * i], dots[2 * i + 1], 2.6 - i / n * 1.3);
    }
    ctx.globalAlpha = 1;
  }
  var FIRE = ['#FFFFFF', '#FFE27A', '#FFB23A', '#FF7A1A', RED, '#5a1a1a'];
  function drawParts() {
    var i, p, q;
    for (i = 0; i < parts.length; i++) {                           // smoke, behind everything else
      p = parts[i]; if (p.k !== 'smoke') continue; q = p.t / p.life;
      ctx.globalAlpha = .45 * (1 - q); ctx.fillStyle = '#6b6b6b'; circle(p.x, p.y, p.r * (1 + q * 1.6));
    }
    for (i = 0; i < parts.length; i++) {                           // splinters of the boxes
      p = parts[i]; if (p.k !== 'shard') continue;
      ctx.globalAlpha = Math.min(1, (p.life - p.t) / .5);
      ctx.save(); ctx.translate(p.x, -p.y); ctx.rotate(p.rot); ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); ctx.restore();
    }
    ctx.globalCompositeOperation = 'lighter';                      // fire adds up to white-hot where it overlaps
    for (i = 0; i < parts.length; i++) {
      p = parts[i]; q = p.t / p.life;
      if (p.k === 'fire') {
        ctx.globalAlpha = 1 - q * q; ctx.fillStyle = FIRE[Math.min(FIRE.length - 1, (q * FIRE.length) | 0)];
        circle(p.x, p.y, p.r * (.7 + q * .9));
      } else if (p.k === 'spark') {
        ctx.globalAlpha = 1 - q; ctx.strokeStyle = '#FFE27A'; ctx.lineWidth = 1.6;
        ctx.beginPath(); ctx.moveTo(p.x, -p.y); ctx.lineTo(p.x - p.vx * .03, -(p.y - p.vy * .03)); ctx.stroke();
      }
    }
    ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
  }

  /* ----------------------------------------------------------------- claim
     Decide inside the tap: by now Postscript's async SDK has long loaded, so if it
     is missing it is blocked. The fallback stays a native link tap so iOS can hand
     an sms: redirect to Messages. */
  // Postscript takes ~1 s (longer on desktop) to draw its pop-up. Closing the game at once left an empty screen (KZA), so
  // the game stays up with "Pulling up form..." on Claim and steps aside the moment Postscript's frame is on screen (4 s
  // at most). "Open" = Postscript's frame has grown to fill the screen, whether or not our hold is hiding it.
  function postscriptShowing() {
    var fs = document.querySelectorAll('iframe[src*="postscript.io"]'), vw = window.innerWidth, vh = window.innerHeight;
    for (var i = 0; i < fs.length; i++) {
      var r = fs[i].getBoundingClientRect();
      if (r.width > vw * 0.5 && r.height > vh * 0.5) return true;
    }
    return false;
  }
  // Reveal Postscript and close the game in the same frame: the form is simply there.
  function revealPostscript() { releaseHold(); root.close(); root.classList.remove('is-claiming'); }
  function handOverWhenShown() {
    root.classList.add('is-claiming');
    var t0 = Date.now();
    (function check() {
      if (!root.open) return;
      if (postscriptShowing() || Date.now() - t0 > 4000) return revealPostscript();
      requestAnimationFrame(check);
    })();
  }
  claimEl && claimEl.addEventListener('click', function (e) {
    if (root.classList.contains('is-claiming')) { e.preventDefault(); return; }
    var ps = window.postscript;
    // KZA 2026-10-20: Postscript's phone field only lays out its +1 country code when it can focus itself as it opens.
    // Built hidden (its own trigger behind the game) or behind a modal (the page is inert), that focus fails. So open it
    // fresh at Claim, VISIBLE, with the page not inert: the game bridges as a non-modal overlay (no inert, z-index just
    // below Postscript's frame) until Postscript's frame covers it. Requires the Postscript trigger = Custom.
    if (cfg.popupId && ps && ps.popups && typeof ps.popups.open === 'function') {
      e.preventDefault();
      claimed = true; writeState({ claimed: Date.now() }); emit('claim', { via: 'postscript-popup' }); hideTab();
      releaseHold();
      root.classList.add('is-claiming');
      root.close(); root.show();                                   // same dialog, now non-modal: the page (and Postscript) is not inert
      try { ps.popups.open(cfg.popupId, { activePopupBehavior: 'ALWAYS_DISMISS', respectPopupStatus: false }); } catch (err) {}
      handOverWhenShown();
      return;
    }
    if (!cfg.fallbackUrl) {                                         // nothing configured yet (QA via ?bom_blast=1)
      e.preventDefault();
      var note = root.querySelector('[data-bbl-setup-note]'); if (note) note.hidden = false;
      return;
    }
    // Postscript's script is blocked or missing: let the native link go to the fallback.
    claimed = true; writeState({ claimed: Date.now() }); emit('claim', { via: 'fallback-link' }); hideTab();
    releaseHold();
  });

  /* ------------------------------------------------- reopen tab (right edge)
     After a dismiss, a slim tab stays on the right edge so the game can be found
     again: "Blow it up" before playing, "Claim it" after the win. */
  var tab = document.querySelector('[data-bbl-tab]');
  function tabWanted(s) {
    if (!tab || s.claimed || !s.dismissed || fromOurTexts()) return false;
    if (!ready && !cfg.force) return false;
    return !(s.tabHidden && Date.now() - s.tabHidden < cfg.cooldownDays * 864e5);
  }
  function showTab(checkSubscriber) {
    if (!tab || claimed || (!ready && !cfg.force)) return;
    tab.setAttribute('data-bbl-won', (won || readState().won) ? 'true' : 'false');
    function reveal() { tab.hidden = false; tab._queueTuck && tab._queueTuck(); }
    if (!checkSubscriber) return reveal();
    isSubscriber(function (sub) { if (!sub) reveal(); });
  }
  function hideTab() { if (tab) tab.hidden = true; }
  if (tab) {
    tab.querySelector('[data-bbl-tab-open]').addEventListener('click', function () { emit('tab-open'); if (!root.open) open(); });
    tab.querySelector('[data-bbl-tab-close]').addEventListener('click', function () { writeState({ tabHidden: Date.now() }); hideTab(); emit('tab-hide'); });
    window.addEventListener('postscriptReady', function () { isSubscriber(function (sub) { if (sub) hideTab(); }); });
    // Never sit on a way to pay: tuck off the edge while overlapping an add-to-bag or sticky buy bar.
    var BUY = 'form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"], .shopify-payment-button, ' +
              'shopify-accelerated-checkout, [class*="sticky"] button, [data-sticky-atc]';
    var tq = false;
    var overlaps = function (a, b) { return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top; };
    var tuck = function () {
      tq = false; if (tab.hidden) return;
      var w = tab.offsetWidth, h = tab.offsetHeight, cy = window.innerHeight * .56;   // resting box, computed (CSS: right 0, top 56%)
      var r = { left: document.documentElement.clientWidth - w - 10, right: window.innerWidth, top: cy - h / 2 - 10, bottom: cy + h / 2 };
      var hit = false, els = document.querySelectorAll(BUY);
      for (var i = 0; i < els.length && !hit; i++) { var b = els[i].getBoundingClientRect(); if (b.width && b.height && overlaps(r, b)) hit = true; }
      tab.classList.toggle('is-tucked', hit);
    };
    var queueTuck = function () { if (!tq) { tq = true; requestAnimationFrame(tuck); } };
    window.addEventListener('scroll', queueTuck, { passive: true });
    window.addEventListener('resize', queueTuck);
    tab._queueTuck = queueTuck;
  }

  // QA: ?bom_blast=1 forces it open from a fresh start (even while switched off); BOM_BLAST.reset() clears the visitor memory.
  window.BOM_BLAST = {
    open: function () { if (!root.open) open(); },
    reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
  };

  buildStack(); loadBomb();
  arm();
})();
